import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../data.service';
import { TaxpayerType } from '../../model/taxpayer-type';
import { InvoiceNumberBookPoint } from '../../model/invoice-number-book-point';
import { InvoicePoint } from '../../model/invoice-point';

@Injectable()
export class InvoicePointService {

  constructor(public http: HttpClient, public dataService: DataService) { }

  private readonly getTaxpayerTypeEndPoint: string = '/invoicePoint/getTaxpayerType/';
  private readonly getInvoicePointsCashDeskEndPoint: string = '/invoicePoint/getInvoicePointsCashDesk/';
  private readonly getInvoicePointsBillingEndPoint: string = '/invoicePoint/getInvoicePointsBilling/';
  private readonly getNextInvoiceNumberEndPoint: string = '/invoicePoint/getNextInvoiceNumber/';
  private readonly getNextInvoiceNumberByParametersEndPoint: string = '/invoicePoint/getNextInvoiceNumberByParameters/';
  private readonly getNextInvoiceCreditNoteNumberEndPoint: string = '/invoicePoint/getNextInvoiceCreditNoteNumber/';

  async getNextInvoiceNumberByParameters(
    invoicePointId: number,
    invoiceTypeId: number,
    invoiceLabelTypeId: number,
    amount: number,
    originalInvoiceNumberBookTypeId?: number,
    clientId?: number): Promise<InvoiceNumberBookPoint> {
    const params = {
      invoicePointId: invoicePointId,
      invoiceTypeId: invoiceTypeId,
      invoiceLabelTypeId: invoiceLabelTypeId,
      amount: amount,
      originalInvoiceNumberBookTypeId: originalInvoiceNumberBookTypeId,
      clientId: clientId
    };
    return await this.dataService.get<InvoiceNumberBookPoint>(this.getNextInvoiceNumberByParametersEndPoint, params).
      toPromise();
  }

  async getInvoicePointsBilling(): Promise<InvoicePoint[]> {
    const params = {};
    return await this.dataService.get<InvoicePoint[]>(this.getInvoicePointsBillingEndPoint, params).toPromise();
  }

  async getInvoicePointsCashDesk(): Promise<InvoicePoint[]> {
    const params = {};
    return await this.dataService.get<InvoicePoint[]>(this.getInvoicePointsCashDeskEndPoint, params).toPromise();
  }

  async getTaxpayerType(): Promise<TaxpayerType[]> {
    const params = {};
    return await this.dataService.get<TaxpayerType[]>(this.getTaxpayerTypeEndPoint, params).toPromise();
  }

  async getNextInvoiceNumber(cashDeskInvoicePointId: number, invoiceLabelTypeId: number): Promise<InvoiceNumberBookPoint> {
    const params = { cashDeskInvoicePointId: cashDeskInvoicePointId, invoiceLabelTypeId: invoiceLabelTypeId};
    return await this.dataService.get<InvoiceNumberBookPoint>(this.getNextInvoiceNumberEndPoint, params).toPromise();
  }

  async getNextInvoiceCreditNoteNumber(cashDeskInvoicePointId: number, invoiceLabelTypeId: number): Promise<InvoiceNumberBookPoint> {
    const params = { cashDeskInvoicePointId: cashDeskInvoicePointId, invoiceLabelTypeId: invoiceLabelTypeId };
    return await this.dataService.get<InvoiceNumberBookPoint>(this.getNextInvoiceCreditNoteNumberEndPoint, params).toPromise();
  }
}
